import React, { useEffect, useState } from "react";
import { DimensionFieldsModel } from "../../_core/_model";
import { GetDimensionFields } from "../../_core/_request.ts";
import { Spinner } from "react-bootstrap";
import { AutoSelectDropdown } from "./AutoSelectDropdown.tsx";

interface request {
    onChange: (v: string) => void,
    iniVal: string,
    items: DimensionFieldsModel[],
    loading: boolean
}
export function DimensionFields({ onChange, iniVal, items, loading }: request) {
    const [curVal, setCurVal] = useState("");

    useEffect(() => {
        setCurVal(iniVal)
    }, [iniVal])
    return (
        loading ?
            <div
                className="d-flex align-items-center gap-2 form-select border rounded bg-card"
            >
                <Spinner size="sm" />
                <span className="text-muted-theme">Loading...</span>
            </div> :
            <AutoSelectDropdown
                placeholder={items.length > 0 ? "Select a Field" : "Select a Dimension first"}
                options={items.map((d) => (
                    { id: d.columnName, name: d.columnDescription }
                ))}
                initSelect={curVal}
                onSelect={(v) => {
                    onChange(v)
                }}
                emptyString=""
            />
    )
}

export default DimensionFields;